import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { isCanUseProffitSearch } from '../../../../../helpers/auth';
import { propShape } from '../../../../../helpers/custom-prop-types';
import ProffitSearchWarnings from '../../../../Ui/Warning/ProffitSearchWarnings';
import ProfessionalMyPageTopProffitSearchContent from './ProfessionalMyPageTopProffitSearchContent';
import ProfessionalMyPageTopProffitSearchMainBanner from './ProffitSearchMainBanner';
const ProfessionalMyPageTopProffitSearch = (props) => {
    const { profile } = props;
    const { isAccountDisable, isCanUseProffitSearchUser } = useMemo(() => ({
        isAccountDisable: !!(profile.proffitSearch && profile.proffitSearch.isAccountDisable),
        isCanUseProffitSearchUser: isCanUseProffitSearch(profile),
    }), [profile]);
    if (isAccountDisable) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [isCanUseProffitSearchUser ? (_jsx(ProfessionalMyPageTopProffitSearchContent, { profile: profile })) : (_jsx(ProfessionalMyPageTopProffitSearchMainBanner, {})), _jsx(ProffitSearchWarnings, { profile: profile })] }));
};
ProfessionalMyPageTopProffitSearch.propTypes = {
    profile: propShape().isRequired,
};
export default ProfessionalMyPageTopProffitSearch;
